import styles from "./button.module.scss";

export enum ButtonType {
    getStarted = "get-started-button",
    viewPlans = "view-plans-button",
    calculatorTop = "calculator-top-button",
    private = "private-button",
    shared = "shared-button",
    purchase = "purchase-button",
    trial = "trial-button",
}

interface ButtonProps {
    children: React.ReactNode;
    type: ButtonType;
    onClick?: () => void;
    className?: string;
    active?: boolean;
    disabled?: boolean;
    proxy_subtype?: "residential" | "mobile" | "private" | "shared";
}

export default function Button({ children, type, onClick, className, active = false, disabled = false, proxy_subtype }: ButtonProps) {
    return (
        <button className={`${styles.button} ${styles[type]} ${active ? styles.active : ""} ${className || ""} ${disabled ? styles.disabled : ""} ${proxy_subtype ? styles[proxy_subtype] : ""}`} onClick={disabled ? undefined : onClick}>
            {children}
        </button>
    );
}
